/**
* @Author: zachalam
* @Date:   2017-01-19T15:51:57-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-08-01T15:05:09-07:00
*/

import React, { Component } from 'react';
import HeaderNavContainer from '../containers/HeaderNavContainer';
import HeaderOut from './blocks/HeaderOut';
import NagBar from './common/NagBar';
import { ToastContainer } from 'react-toastify';
import '../style/normalize.css';
import '../style/toastify-theme.css';
import Loader from 'react-loading-overlay';
import TosModal from './common/TosModal'
import MTFooter from './blocks/MTFooter'
import { color, dimensions } from '../style';
import glamorous from 'glamorous';

const AllContent = glamorous.div({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column'
});

const MainContent = glamorous.div(
  {},
  (({loggedOut}) => ({
    minHeight:
      loggedOut ?
      // 100vh - (HeaderOut and footer)
      "calc(100vh - 389px)"
      // 100vh - (HeaderNavContainer and footer)
      : "calc(100vh - 297px)",
    [dimensions.SCREEN_MAX_LG]: {
      minHeight: loggedOut ? "calc(100vh - 533px)" : "calc(100vh - 441px)"
    }
  }))
);

class App extends Component {
  renderTosModal = () => {
    const {
      show_tos,
      profile,
      requestGdprDeletion,
      gdprDeletionError,
      acceptTos,
      tos,
      privacyPolicy
    } = this.props;

    if(!tos ||!tos.item || !privacyPolicy || !privacyPolicy.item) return null;

    return(
      <TosModal
        isOpen={show_tos}
        profile={profile.profile.data}
        requestGdprDeletion={requestGdprDeletion}
        gdprDeletionError={gdprDeletionError}
        acceptTos={acceptTos}
        tos={tos}
        privacyPolicy={privacyPolicy}
      />
    )
  }

  componentWillReceiveProps(nextProps) {
    const {
      show_tos,
      getTosText,
      tos,
      getPrivacyPolicy
    } = nextProps;

    if(show_tos && tos && tos.item === null) {
      getTosText();
      getPrivacyPolicy();
    }

  }

  render() {
    let page = this.props.location.pathname;
    let publicPages = ['','/login','/join','/join-profile','/restoring'];
    let joinPage = ['/join'];
    let footerlessPages = ['messages', 'search'];
    let hasMobileHiddenHeader = ['messages'];
    let isSearch = Boolean(this.props.location.pathname.indexOf('search')>=0)
    let isPublic = Boolean(publicPages.indexOf(page)>=0);
    let isJoinPage = Boolean(joinPage.indexOf(page)>=0);
    let isFooterless = Boolean(footerlessPages.indexOf(page.split('/')[1])>=0);
    let isHeaderHiddenMobile = Boolean(hasMobileHiddenHeader.indexOf(page.split('/')[1])>=0)

    var ToastCloseBtn = ({closeToast}) => (
      <div className='toastify__closeContainer' onClick={closeToast}>
        <i className='toastify__close'>
          <svg viewBox="0 0 12 12" height="12" width="12" version="1.1"
            xmlns="http://www.w3.org/2000/svg">
            <line x1="1" y1="11"
              x2="11" y2="1"
              stroke="#FFF"
              strokeWidth="3"/>
            <line x1="1" y1="1"
              x2="11" y2="11"
              stroke="#FFF"
              strokeWidth="3"/>
            </svg>
        </i>
      </div>
    )

    var loggedOut = !this.props.username || (this.props.profile.profile === undefined);

    return (
      <div id='app' style={{ minHeight: isHeaderHiddenMobile ? '100%' : 'calc(100% - 65px)', background: isSearch ? color.BRAND_1_DARK : "inherit"}}>
        {loggedOut ? '' : this.renderTosModal()}
        <Loader active={this.props.isFetching} spinner text={'loading...'} color={color.BRAND_1} background="#fff" zindex={999} minHeight='calc(100vh - 65px)' display='flex' flexDirection='column'>
          <AllContent style={{marginTop: isHeaderHiddenMobile ? 0 : 65, minHeight: isHeaderHiddenMobile ? '100vh' : 'calc(100vh - 65px)'}}>
          {loggedOut || (isJoinPage) ? <HeaderOut /> : <HeaderNavContainer hiddenMobile={isHeaderHiddenMobile} {...this.props} /> }
            {/* {loggedOut || this.props.profile.email_confirmed ? '' : <NagBar resendEmail={this.props.resendEmail} />} */}
            {loggedOut || <NagBar />}
            <MainContent loggedOut={loggedOut}>
              {this.props.children}
            </MainContent>
          {!isFooterless && <MTFooter contentColor="black" backgroundColor="white"/> }
          <ToastContainer autoClose={1500} position="top-center" closeButton={<ToastCloseBtn />}/>
        </AllContent>
        </Loader>
      </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx